import { render, staticRenderFns } from "./DepartmentDetail.vue?vue&type=template&id=5aa72f83&"
import script from "./DepartmentDetail.vue?vue&type=script&lang=js&"
export * from "./DepartmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports